export async function lookupProductData(productId, sellingPlan) {
  return new Promise((resolve, reject) => {
    // Attempt to retrieve the product data from localStorage
    const productsStore = JSON.parse(localStorage.getItem('products')) || {};
    const productData = productsStore[productId];

    // Check if the product data exists
    if (productData) {
      const trackedProductCardIds = JSON.parse(localStorage.getItem('trackedProductCardIds')) || [];
      const trackedProduct = trackedProductCardIds.find(product => product.id === productId);
      // console.log('Tracked Product:', trackedProduct);
      if (trackedProduct && trackedProduct.index) {
        // console.log('Product found in trackedProductCardIds:', trackedProduct);
        // console.log('Product found in trackedProductCardIds.index:', trackedProduct.index);
        productData.index = trackedProduct.index ?? 0;
      }
      // pass a variable to item_category5 in the object store
      if (sellingPlan !== null) {
        productData.item_category5 = sellingPlan;
      } else {
        productData.item_category5 = "one_time|subscription";
      }
      resolve(productData);
    } else {
      reject(new Error(`Product ${productId} data not found in localStorage`));
    }
  });
}